import { Stack, Theme, useMediaQuery } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"

const DashboardHomepageSkeleton = (): ReactElement => {
    const matches = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("md")
    )

    return (
        <Stack
            direction={{ xs: "column", md: "column" }}
            spacing={GRID_SPACING}
            alignItems="stretch"
        >
            <Stack>
                <AppSkeleton height={70} width={matches ? "100%" : 300} />
            </Stack>

            <Stack
                direction={{ xs: "column", md: "row" }}
                gap={GRID_SPACING}
                justifyContent="space-evenly"
                marginBottom={GRID_SPACING}
            >
                <AppSkeleton height={125} width={matches ? "100%" : "33%"} />
                <AppSkeleton height={125} width={matches ? "100%" : "33%"} />
                <AppSkeleton height={125} width={matches ? "100%" : "33%"} />
            </Stack>

            <Stack
                direction={{ xs: "column", md: "row" }}
                gap={GRID_SPACING}
                justifyContent="center"
                marginBottom={GRID_SPACING}
            >
                <AppSkeleton height={600} width={matches ? "100%" : "50%"} />
                <AppSkeleton height={600} width={matches ? "100%" : "50%"} />
            </Stack>
        </Stack>
    )
}

export default DashboardHomepageSkeleton
